import {Injectable} from '@angular/core';
import {Workbook, Column} from 'exceljs';
import * as ExcelProper from "exceljs";
import * as fs from 'file-saver';

@Injectable({
  providedIn: 'root'
})
/***
 * Servicio para exportar a excel
 * @author Isaelsolis
 * @since 1.0.0
 * @date 2024-04-23
 **/
export class ExcelServiceService {

  constructor() {
  }

  exportToExcel(gridOptions: any, options: any) {

    let {rowsToDisplay} = gridOptions.getModel() as any;
    let data = rowsToDisplay.map(row => row.data);

    let workbook: ExcelProper.Workbook = new Workbook();
    let worksheet = workbook.addWorksheet(options.sheetName);
    worksheet.columns = options.columns.map((column: Column) => {
      let headerCol: Partial<Column> = {
        header: column.header,
        key: column.key,
        width: column.width,
      }
      return headerCol
    });

    // Fill data
    data.forEach((row: any) => {
      let newRow = {};
      options.columns.forEach((column: any) => {
        if (column.valueGetter) {
          newRow[column.key] = column.valueGetter(row);
        } else {
          newRow[column.key] = row[column.key];
        }
      });
      worksheet.addRow(newRow);
    });

    // Set alignment for all rows (wrapText: true for the moment, but can be extended to other properties)
    let rowIndex = 1;
    for (rowIndex; rowIndex <= worksheet.rowCount; rowIndex++) {
      worksheet.getRow(rowIndex).alignment = {vertical: 'top', horizontal: 'left', wrapText: true};
    }

    // get cells of the header
    worksheet.getRow(1).eachCell((cell, colNumber) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: {argb: '0070C0'},
        bgColor: {argb: '0070C0'}
      };
      cell.font = {color: {argb: 'FFFFFF'},  bold: true};
    });

    // Add filter to the header
    worksheet.autoFilter = {
      from: {
        row: 1,
        column: 1
      },
      to: {
        row: 1,
        column: options.columns.length
      }
    };

    // Save file
    workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
      fs.saveAs(blob, options.fileName);
    })
  }

  exportToExcelSimpleData(columnas: string[], datos: any[], nombre: string) {
    const workbook = new ExcelProper.Workbook();
    const worksheet = workbook.addWorksheet(nombre);

    worksheet.addRow(columnas);

    datos.forEach(fila => {
     // console.log(fila);
      worksheet.addRow(fila);
    });


    workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
      fs.saveAs(blob, nombre);
    })

  }

}
